import { render } from "./Slogan.vue?vue&type=template&id=49f04262&scoped=true"
const script = {}

import "./Slogan.vue?vue&type=style&index=0&id=49f04262&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49f04262"]])

export default __exports__